import { xor } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { navigateToProjectReports } from '../../../links/index.jsx';
import {
  retrieveProjectStatuses,
  selectProjectStatuses,
} from '../../../../modules/projectStatuses.js';

const mapStateToProps = (state) => ({
  customProjectStatuses: selectProjectStatuses(state),
});

const mapDispatchToProps = {
  retrieveProjectStatuses,
};

function StatusesFilter({
  customProjectStatuses,
  selectedStatusesIds,
  retrieveProjectStatuses,
}) {
  const selectedCount = selectedStatusesIds.length;

  const handleSelect = useCallback(
    (statusId) =>
      navigateToProjectReports({
        projectStatusIds: statusId ? xor(selectedStatusesIds, [statusId]) : [],
      }),
    [selectedStatusesIds]
  );

  const renderMenuItem = useCallback(
    (status) => (
      <React.Fragment key={status.id}>
        <MenuItem
          active={selectedStatusesIds.includes(status.id)}
          eventKey={status.id}
          onSelect={handleSelect}
        >
          <span className={status.archived ? 'text-muted' : ''}>
            {status.name}
          </span>
        </MenuItem>
      </React.Fragment>
    ),
    [selectedStatusesIds]
  );

  useEffect(() => {
    retrieveProjectStatuses();
  }, []);

  return (
    <div className="report-filter" style={{ flex: 1 }}>
      <div className="text-muted filter-label">Status</div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="statuses-filter"
          className="btn-block"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          <MenuItem divider />
          {customProjectStatuses
            .filter((s) => s.projectsCount > 0)
            .map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

StatusesFilter.propTypes = {
  customProjectStatuses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  selectedStatusesIds: PropTypes.arrayOf(PropTypes.number),
};

StatusesFilter.defaultProps = {
  customProjectStatuses: [],
  selectedStatusesIds: [],
};

export default connect(mapStateToProps, mapDispatchToProps)(StatusesFilter);
